import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#18181B] text-white pt-24 pb-8 px-6 lg:px-12 overflow-hidden flex flex-col relative">
      <div className="max-w-7xl mx-auto w-full mb-20 z-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        
        {/* Brand & Socials */}
        <div className="lg:col-span-1">
          <div className="flex items-center gap-3 mb-6">
            <img src={logo} alt="340 Real Estate" className="w-10 h-10 object-contain brightness-0 invert opacity-90" />
            <span className="font-bold text-lg tracking-tight font-display">340 Real Estate</span>
          </div>
          <p className="text-gray-400 text-sm leading-relaxed mb-8">
            In 1917 the United States bought St. John from Denmark. By the 1930s, news of the beautiful American island quickly spread...
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="font-semibold mb-6 text-sm tracking-widest uppercase text-gray-500 font-display">Quick Links</h3>
          <ul className="space-y-4 text-sm text-gray-300 font-light">
            <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
            <li><a href="https://340realestate.com/about" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">About St. John</a></li>
            <li><a href="https://340realestate.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Privacy Policy</a></li>
            <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            <li><a href="https://340realestate.com/terms" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Terms of Use</a></li>
          </ul>
        </div>

        {/* Explore */}
        <div>
          <h3 className="font-semibold mb-6 text-sm tracking-widest uppercase text-gray-500 font-display">Explore</h3>
          <ul className="space-y-4 text-sm text-gray-300 font-light">
            <li><a href="https://340realestate.com/rentals" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Villa Rentals</a></li>
            <li><a href="https://340realestate.com/sales-history" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Sales History</a></li>
            <li><Link to="/properties" className="hover:text-white transition-colors">For Sale</Link></li>
            <li><Link to="/testimonials" className="hover:text-white transition-colors">Testimonials</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h3 className="font-semibold mb-6 text-sm tracking-widest uppercase text-gray-500 font-display">Contact Info</h3>
          <ul className="space-y-4 text-sm text-gray-300 font-light">
            <li>
              <a 
                href="https://maps.google.com/?q=340+Real+Estate+Company,+St.+John,+VI" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-white transition-colors"
              >
                PO Box 766, St John, VI 00831
              </a>
            </li>
            <li><a href="tel:+13406436068" className="hover:text-white transition-colors">+1 340-643-6068</a></li>
            <li><a href="tel:+13407794478" className="hover:text-white transition-colors">+1 340-779-4478</a></li>
            <li><a href="mailto:340realestateco@gmail.com" className="hover:text-white transition-colors">340realestateco@gmail.com</a></li>
          </ul>
        </div>

      </div>

      {/* Giant Background Text Area */}
      <div className="w-full flex justify-center items-end mt-10 relative z-0">
        <h1 className="text-[12vw] sm:text-[14vw] font-bold text-white/[0.03] leading-none tracking-tighter whitespace-nowrap font-display select-none">
          340 Real Estate
        </h1>
        {/* Bottom Bar overlaying the giant text slightly */}
        <div className="absolute bottom-0 w-full max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center text-xs text-gray-500 border-t border-white/10 pt-6 z-10 pb-2">
          <p>© {currentYear} 340 Real Estate St. John. All rights reserved.</p>
          <p className="mt-2 sm:mt-0">Licensed Broker | St. John & St. Thomas Board of Realtors</p>
        </div>
      </div>

    </footer>
  );
};

export default Footer;
